import { CountryNoteGroup } from "@oysterhr/schema"

interface CountryNotesProps {
  noteGroup: CountryNoteGroup
}

const CountryNotes = ({ noteGroup }: CountryNotesProps) => {
  return (
    <div className="mt-4 flex flex-col text-left first:mt-0">
      <span className="text-sm font-semibold">{noteGroup.name}</span>
      <ul className="list-inside list-disc whitespace-pre-line">
        {noteGroup.notes.map(note => (
          /* eslint-disable react/no-danger */
          <li
            className="text-sm text-gray-400"
            key={note}
            dangerouslySetInnerHTML={{ __html: note }}
          />
          /* eslint-enable react/no-danger */
        ))}
      </ul>
    </div>
  )
}

export default CountryNotes
